onDomLoad(function () {
  document
    .querySelectorAll("[data-target='template-children-modal']")
    .forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()

        const url = element.dataset.url

        window.modalCitizen.openModal('template-children-modal', { url })
      })
    })
})
